/**
 * Every temporary object URL is created and revoked here, so no Blob URL
 * outlives its consumer. ALG-058
 */
const live = new Map<string, string>();

export function createObjectUrl(owner: string, source: Blob | MediaSource): string {
  const url = URL.createObjectURL(source as Blob);
  live.set(url, owner);
  return url;
}

export function revokeObjectUrl(url: string | null | undefined): void {
  if (!url) return;
  if (live.delete(url)) URL.revokeObjectURL(url);
}

export function revokeAllFor(owner: string): void {
  for (const [url, o] of [...live]) {
    if (o === owner) {
      URL.revokeObjectURL(url);
      live.delete(url);
    }
  }
}

export function liveObjectUrlCount(): number {
  return live.size;
}
